<template>
  <div class="px-6 pt-6 mb-6">
    <div class="images flex justify-between flex-nowrap">
      <div class="mb-10 w-1/2">
        <div class="mb-2">Banner Image</div>
        <a class="text-xs cursor-pointer" @click="uploadImage('top_banner')">Change Banner</a>
        <hr>
        <img v-if="banner" :src="banner" alt="">
      </div>

      <div class="mb-10 w-1/2">
        <div class="mb-2">Logo Image</div>
        <a class="text-xs cursor-pointer" @click="uploadImage('logo')">Change Logo</a>
        <hr>
        <img width="120" height="120" v-if="logo" :src="logo" alt="">
      </div>
    </div>
    <div class="hero flex justify-between flex-nowrap">
      <div class="mb-10">
        <div class="mb-2">Hero Images (Major)</div>
        <a class="text-xs cursor-pointer" @click="uploadImage('major')">Add Images</a>
        <hr>
        <el-table
          :data="majorHeroImages"
          style="width: 100%">
          <el-table-column
            prop="url"
            label="Image"
            width="180">
            <template slot-scope="scope">
              <img style="height: 100px!important; width: 120px!important;" :src="scope.row.url" alt="">
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="Action">
            <template slot-scope="scope">
              <el-button @click="deleteImage(scope.row.id)" type="text" size="small">
                <i class="text-sm text-red-500 el-icon-delete-solid"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="mb-10">
        <div class="mb-2">Hero Images (Minor)</div>
        <a class="text-xs cursor-pointer" @click="uploadImage('minor')">Add Images</a>
        <hr>
        <el-table
          :data="minorHeroImages"
          style="width: 100%">
          <el-table-column
            prop="url"
            label="Image"
            width="180">
            <template slot-scope="scope">
              <img style="height: 100px!important; width: 120px!important;" :src="scope.row.url" alt="">
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="Action">
            <template slot-scope="scope">
              <el-button @click="deleteImage(scope.row.id)" type="text" size="small">
                <i class="text-sm text-red-500 el-icon-delete-solid"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <UploadModal />
  </div>
</template>

<script>
import UploadModal from './_includes/UploadModal.vue';

export default {
  name: 'Images',
  components: {
    UploadModal,
  },
  computed: {
    logo() {
      return this.$store.state.SettingsModule.Config.profile.logo;
    },

    banner() {
      return this.$store.state.SettingsModule.Config.profile.top_banner;
    },

    majorHeroImages() {
      return this.$store.state.SettingsModule.Config.profile.hero_images
        .filter(item => item.type === 'major')
        .map(item => ({ url: item.image_url, id: item.id }));
    },

    minorHeroImages() {
      return this.$store.state.SettingsModule.Config.profile.hero_images
        .filter(item => item.type === 'minor')
        .map(item => ({ url: item.image_url, id: item.id }));
    },
  },
  methods: {
    uploadImage(type) {
      if (type === 'minor' && this.minorHeroImages.length > 3) {
        this.$alert('You can not have more than 4 Minor images.', 'Warning', {
          type: 'warning',
          center: true,
        });
      } else {
        this.$modal.show('image-upload', { type });
      }
    },
    deleteImage(id) {
      this.$confirm('This will permanently delete this image. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/Config/deleteHeroImages', { id });
          await this.$store.dispatch('SettingsModule/Config/fetchMerchantProfile');

          this.$notify.success({
            title: 'Success',
            message: 'Image successfully removed',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  a {
    color: #0A6ABF;
    text-decoration: underline;

    &:hover {
     color: #007bff;
    }
  }

  .hero div {
    flex: 0 1 48%
  }

  .images div {
    flex: 0 1 48%
  }
</style>
